import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import { isUserLoggedIn } from "@/auth/utils";
import store from "@/store";
import axios from "@axios";
import dashboard from "./routes/dashboard";
import account from "./routes/account-management";
import pages from "./routes/pages";
import managefops from "./routes/manage-fop";
import company from "./routes/company";
import orders from "./routes/orders";
import others from "./routes/others";
import refund from "./routes/refund";
import reports from "./routes/report";
import reconciliation from "./routes/reconciliation";
import monitoring from "./routes/monitoring";
import commision from "./routes/commission";
import provider from "./routes/provider";
import transactionStatus from "./routes/transaction-status";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home-flyGate",
      component: () => import("@/views/home/index.vue"),
      meta: {
        resource: "Home",
        action: "View",
      },
    },
    ...dashboard,
    ...account,
    ...pages,
    ...managefops,
    ...company,
    ...orders,
    ...others,
    ...refund,
    ...reconciliation,
    ...reports,
    ...monitoring,
    ...commision,
    ...provider,
    ...transactionStatus,
    {
      path: "*",
      redirect: "error-404",
    },
    {
      path: "/:hash(.*)",
      redirect: "error-404",
    },
  ],
});
let authInitialized = false;
let userIsAuthenticated = false;

const initAuth = () => {
  if (authInitialized) return Promise.resolve(userIsAuthenticated);
  authInitialized = true;
  return axios
    .get("/User/api/V1.0/Account/LogInAuthorization")
    .then((res) => {
      store.dispatch("permission/handlePermission", res);
      userIsAuthenticated = true;
      return true;
    })
    .catch(() => {
      userIsAuthenticated = false;
      return false;
    });
};

export const setUnauthenticated = () => {
  userIsAuthenticated = false;
};
export const setAuthenticated = () => {
  authInitialized = true;
  userIsAuthenticated = true;
};

router.beforeEach(async (to, _, next) => {
  const isAuthRoute = to.meta?.resource === "Auth";

  // only call initAuth on reload when heading to a protected route
  if (!isAuthRoute) await initAuth();

  const isLoggedIn = userIsAuthenticated;

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: "auth-login" });
    return next({ name: "misc-not-authorized" });
  }
  if (to.meta?.redirectIfLoggedIn && isLoggedIn) return next("/");
  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
